import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

// Drawer-style entity record. Same authoring shape as manage (summary + tabs);
// the host renders narrower in a drawer with a footer (Flag/Manage/Refresh).
// Read-biased: defaultFieldMode is 'inplace' so fields render as values until
// clicked. Patch-on-blur autosave when edited.
export const quickViewSurface = {
  id: SurfaceType.QuickView,
  saveStrategy: 'patch',
  defaultFieldMode: 'inplace',
  viewStatePersistence: 'url',
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.QuickView],
} as const satisfies SurfaceTypeDefinition<SurfaceType.QuickView>;
